var render, staticRenderFns
import script from "./ModelPerformanceChart.vue?vue&type=script&lang=js&"
export * from "./ModelPerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/suspicious_login/suspicious_login/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3ebc952')) {
      api.createRecord('e3ebc952', component.options)
    } else {
      api.reload('e3ebc952', component.options)
    }
    
  }
}
component.options.__file = "src/components/ModelPerformanceChart.vue"
export default component.exports